var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a711dff7-d2fd-4d85-a723-b87b51c3a339",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81.02 81.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9bf9622-ad1f-48e8-8aeb-e51181a5cc1f",
    x1: 40.51,
    y1: 81.02,
    x2: 40.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e82fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56a2fe"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 81.02,
    height: 81.02,
    rx: 26.91,
    style: {
      fill: "url(#a9bf9622-ad1f-48e8-8aeb-e51181a5cc1f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.14,28.08H43a7.49,7.49,0,0,1,7.49,7.49V49.82a3.24,3.24,0,0,1-3.24,3.24H25.38a7.49,7.49,0,0,1-7.49-7.49V31.32A3.24,3.24,0,0,1,21.14,28.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.29,46.75l7.06,5.85a1.7,1.7,0,0,0,2.78-1.31V29.65a1.7,1.7,0,0,0-2.79-1.29l-7.06,5.92a2,2,0,0,0-.71,1.51v9.44A2,2,0,0,0,53.29,46.75Z",
    style: {
      fill: "#fff"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.8aaf3a98c063ccc04bf99db1becf622f.svg";
export { ForwardRef as ReactComponent };